import { render, staticRenderFns } from "./TaskTypes.vue?vue&type=template&id=8220a3f4&scoped=true&"
import script from "./TaskTypes.vue?vue&type=script&lang=js&"
export * from "./TaskTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8220a3f4",
  null
  
)

export default component.exports